//スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//ナビゲーション用
$(function(){
	$('#gnav_btn').on('click', function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('header nav').removeClass('open').stop().slideUp(200);
			$('body').removeClass('add_overray');
		}else{
			$(this).addClass('open');
			$('header nav').addClass('open').stop().slideDown(600);
			$('body').addClass('add_overray');
		}
	});
	$('.outside').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
	$('header nav a').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
});


//フェードイン
$(function(){
    $(window).scroll(function (){
        $('.fadein').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 50){
                $(this).addClass('scrollin');
            }
        });
    });
});

$(function() {
	$('#archive_top a[href^="#panel"]').click(function(){
		$("#archive_top .panel").hide();
		$(this.hash).fadeIn(2000);
		return false;
	});
	$('#archive_top a[href^="#panel"]:eq(0)').trigger('click');
})


$('.slide').slick({
	autoplay: true, //自動再生
	infinite: true, //スライドのループ有効化
	draggable: true,
	arrows: true,
	slidesToShow: 5, //表示するスライドの数
	slidesToScroll: 5, //スクロールで切り替わるスライドの数
	responsive: [{
		breakpoint: 768, //ブレークポイントが768px
		settings: {
		slidesToShow: 3, //表示するスライドの数
		slidesToScroll: 3, //スクロールで切り替わるスライドの数
		}
	}]
});